/**
 * Share token utilities.
 * Used for:
 *   - Cart sharing (2A)
 *   - Maintenance pay-links (2B, future)
 */

export const generateToken = (length = 12) => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
  let out = '';
  const bytes = new Uint8Array(length);
  if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  for (let i = 0; i < length; i++) {
    out += chars[bytes[i] % chars.length];
  }
  return out;
};

export const makeShareToken = (hoursValid = 72) => {
  const now = Date.now();
  return {
    token: generateToken(12),
    createdAt: now,
    expiresAt: now + hoursValid * 60 * 60 * 1000,
    sharedWith: null,
  };
};

export const isTokenValid = (shareToken) => {
  if (!shareToken?.token || !shareToken?.expiresAt) return false;
  return shareToken.expiresAt > Date.now();
};

export const msUntilExpiry = (shareToken) => {
  if (!shareToken?.expiresAt) return 0;
  return Math.max(0, shareToken.expiresAt - Date.now());
};

export const formatTimeLeft = (ms) => {
  if (ms <= 0) return 'Expired';
  const hours = Math.floor(ms / (60 * 60 * 1000));
  const mins = Math.floor((ms % (60 * 60 * 1000)) / (60 * 1000));
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    return `${days} day${days === 1 ? '' : 's'} left`;
  }
  if (hours >= 1) return `${hours}h ${mins}m left`;
  return `${mins}m left`;
};

export const buildCartShareUrl = (token) => {
  if (typeof window === 'undefined') return `https://skytone.app/cart/${token}`;
  return `${window.location.origin}/cart/${token}`;
};